import {
  ChakraBox,
  ChakraAccordion,
  ChakraAccordionItem,
  ChakraAccordionButton,
  ChakraAccordionPanel,
  ChakraAccordionIcon,
} from "@airhelp/react-ui-components";
import type { MenuExtendedProps } from "config/menus/menus.d";
import { accordionButtonStyles } from "./MenuLinkWithSubmenu.styles";
import { SubmenuContent } from "./SubmenuContent";

export const MenuLinkWithSubmenuMobile = ({
  menulink,
  submenu,
}: {
  submenu: MenuExtendedProps["subMenu"];
  menulink: JSX.Element;
}) => (
  <ChakraAccordion allowToggle>
    <ChakraAccordionItem border="none" bg="transparent">
      <ChakraAccordionButton
        py={0}
        pl={0}
        fontSize="lg"
        borderRadius="sm"
        data-testid="open-kyr-items"
        sx={accordionButtonStyles}
      >
        <ChakraBox flex="1" textAlign="left">
          {menulink}
        </ChakraBox>
        <ChakraAccordionIcon boxSize={6} />
      </ChakraAccordionButton>
      <ChakraAccordionPanel px={4}>
        <SubmenuContent
          submenu={submenu}
          fontSize="md"
          color="greyscale.600"
          _hover={{ color: "primary.500" }}
          data-testid="kyr-list-items"
        />
      </ChakraAccordionPanel>
    </ChakraAccordionItem>
  </ChakraAccordion>
);
